export default {
	props: {
		block: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: null
		},
		variant: {
			type: String,
			default: null
		},
		type: {
			type: String,
			default: 'button'
		},
		tag: {
			type: String,
			default: 'button'
		},
		pressed: {
			// tri-state prop: true, false or null
			// => on, off, not a toggle
			type: Boolean,
			default: null
		},
		href: {
			type: String,
			default: null
		},
		rel: {
			type: String,
			default: null
		},
		target: {
			type: String,
			default: '_self'
		},
		active: {
			type: Boolean,
			default: false
		},
		// router-link specific props
		to: {
			type: [String, Object],
			default: null
		},
		append: {
			type: Boolean,
			default: false
		},
		replace: {
			type: Boolean,
			default: false
		},
		event: {
			type: [String, Array],
			default: 'click'
		},
		activeClass: {
			type: String
			// default: undefined
		},
		exact: {
			type: Boolean,
			default: false
		},
		exactActiveClass: {
			type: String
			// default: undefined
		},
		routerTag: {
			type: String,
			default: 'a'
		},
		// nuxt-link specific prop(s)
		noPrefetch: {
			type: Boolean,
			default: false
		},
	}
};